import { AnyAction } from 'redux';
import { ILoadingError } from '#/types/global';
import { IArtistAlbums, IArtistResponse } from '#/types/API/artists';
import {
  createActionArtistAddDetails,
  createActionArtistErrorDetails,
  createActionArtistStartLoading,
  createActionArtistSetAlbumType,
  createActionArtistStopLoading,
  createActionArtistSetAlbums,
  createActionArtistSetIsFollowed,
  createActionArtistReset,
  createActionArtistSetTrackIsFavorite,
} from '../actions/artist';
import ITrackResponse from '#/types/API/tracks';

export interface ITrackWithFavorite extends ITrackResponse {
  favorite: boolean;
}

export interface IArtist {
  details?: IArtistResponse;
  topTracks?: ITrackWithFavorite[];
  albums?: IArtistAlbums;
  apearsOn?: IArtistAlbums;
  relatedArtists?: IArtistResponse[];
  isFollowed?: boolean;
  selectedAlbumType?: string;
}

type TState = IArtist & ILoadingError;

// eslint-disable-next-line unicorn/no-null
const initialState: TState = { _loading: true, _error: false };

const artist = (state: TState = initialState, action: AnyAction): TState => {
  if (createActionArtistAddDetails.doesMatch(action)) {
    return { ...state, ...action.payload };
  }

  if (createActionArtistStartLoading.doesMatch(action)) {
    return { ...state, _loading: true };
  }

  if (createActionArtistStopLoading.doesMatch(action)) {
    return { ...state, _loading: false };
  }

  if (createActionArtistErrorDetails.doesMatch(action)) {
    return { ...state, _error: true };
  }

  if (createActionArtistSetAlbumType.doesMatch(action)) {
    return { ...state, selectedAlbumType: action.payload };
  }

  if (createActionArtistSetAlbums.doesMatch(action)) {
    return { ...state, albums: action.payload };
  }

  if (createActionArtistSetIsFollowed.doesMatch(action)) {
    return { ...state, isFollowed: action.payload };
  }

  if (createActionArtistSetTrackIsFavorite.doesMatch(action)) {
    if (state.topTracks) {
      const indexTrack = state.topTracks.findIndex(
        (track) => track.id === action.payload.track
      );
      if (indexTrack !== -1) {
        const newTopTracks = [...state.topTracks];
        newTopTracks[indexTrack].favorite = action.payload.favorite;
        return { ...state, topTracks: newTopTracks };
      }
    }
    return state;
  }

  if (createActionArtistReset.doesMatch(action)) {
    return initialState;
  }

  return state;
};

export default artist;
